import { render, staticRenderFns } from "./HotelsFilters.vue?vue&type=template&id=495c02ac&scoped=true"
import script from "./HotelsFilters.vue?vue&type=script&lang=js"
export * from "./HotelsFilters.vue?vue&type=script&lang=js"
import style0 from "./HotelsFilters.vue?vue&type=style&index=0&id=495c02ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c02ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCaret: require('/home/forge/farescraper.com/components/IconsCaret.vue').default})
